export const mockAPIPath = {
    ORDER_DETAIL_LIST: "",
};

export const serverAPIPath = {
    ORDER_DETAIL_LIST: "/oms/orders", 
};
